<template>
    <b-card no-body>
        <b-card-body>
            <h4 class="heading-1 mb-4">
                <span>APP Sebrae - Consultorias - Unidade Regional</span>
                <div class="float-right" v-if="operacao == 'ATUALIZAR'">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="obterUnidadeRegional()"
                        ></i>
                    </span>
                </div>
            </h4>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label class="required"
                                >Nome da Unidade Regional</label
                            >
                            <b-form-input
                                type="text"
                                placeholder="Informe o nome da unidade regional"
                                v-model="nome"
                                @input.native="$v.nome.$touch()"
                                :state="$v.nome.$error ? false : null"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O nome da unidade regional é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label class="required">Gestor</label>
                            <b-form-select
                                :plain="true"
                                :options="gestores"
                                v-model="codGestor"
                                text-field="nome"
                                value-field="codGestor"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label class="required">Unidade</label>
                        <b-form-select
                            :options="unidades"
                            v-model="codUnidade"
                            text-field="nome"
                            value-field="codUnidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label class="required">Projeto</label>
                        <b-form-select
                            :options="projetos"
                            v-model="codProjeto"
                            text-field="nome"
                            value-field="codProjeto"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label class="required">Ação</label>
                        <b-form-select
                            :options="acoes"
                            v-model="codAcao"
                            text-field="nome"
                            value-field="codAcao"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="confirmarOperacao()"
                :disabled="!habilitarSalvar"
                class="mr-2"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-remove"></i> Cancelar </span>
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import UnidadesRegionaisServicos from './UnidadesRegionaisServicos'
// import UsuariosServicos from './UsuariosServicos'

export default {
    data() {
        return {
            erros: [],
            nome: null,
            codGestor: null,
            gestores: [],
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            unidades: [],
            projetos: [],
            acoes: [],
            unidadeModificada: false
        }
    },

    methods: {
        obterGestores() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterGestores().then((response) => {
                if (response) {
                    if (response.success) {
                        this.gestores = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterUnidades().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                        if (this.operacao == 'INSERIR') {
                            this.codUnidade = this.unidades[0].codUnidade
                        }
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterProjetos(this.codUnidade).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.projetos = response.data
                            if (this.projetos) {
                                if (this.tipo == 'INSERIR') {
                                    this.codProjeto =
                                        this.projetos[0].codProjeto
                                }
                            } else {
                                this.codProjeto = null
                                this.acoes = []
                            }
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterAcoes(
                this.codUnidade,
                this.codProjeto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                        if (this.acoes) {
                            if (this.tipo == 'INSERIR') {
                                this.codAcao = this.acoes[0].codAcao
                            }
                        }
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarOperacao() {
            this.$swal({
                title: 'Unidade Regional',
                html: `Confirma a ${
                    this.operacao == 'INSERIR' ? 'inserção' : 'atualização'
                } da unidade regional ${this.nome.toUpperCase()}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        // salvarForm() {
        //     let usuario = {
        //         nome: this.usuarioDto.nome.toUpperCase(),
        //         login: this.usuarioDto.login.toLowerCase(),
        //         email: this.usuarioDto.email.toLowerCase(),
        //         observacoes: this.usuarioDto.observacoes
        //     }
        //     this.inserirUsuario(usuario)
        // },

        cancelar() {
            this.erros = []
            this.$router.push({
                name: 'AppSebrae_Consultorias_UnidadesRegionais'
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let unidadeRegionalDto = {
                nome: this.nome,
                codGestor: this.gestor.codGestor,
                nomeGestor: this.gestor.nome,
                emailGestor: this.gestor.email,
                codUnidade: this.unidade.codUnidade,
                unidade: this.unidade.nome,
                codProjeto: this.projeto.codProjeto,
                projeto: this.projeto.nome,
                codAcao: this.acao.codAcao,
                acao: this.acao.nome
            }
            let promisse
            if (this.operacao == 'INSERIR') {
                promisse = UnidadesRegionaisServicos.inserir(unidadeRegionalDto)
            } else {
                unidadeRegionalDto.unidadeRegionalId =
                    this.$route.params.unidadeRegionalId
                promisse =
                    UnidadesRegionaisServicos.atualizar(unidadeRegionalDto)
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        if (this.operacao == 'INSERIR') {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.registroSalvoComSucesso(
                                this.$route.params.unidadeRegionalId
                            )
                        }
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(unidadeRegionalId) {
            this.erros = []
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$store.dispatch('setRecarregar', true)
            this.$router.push({
                name: 'AppSebrae_Consultorias_UnidadesRegionais_Detalhar',
                params: { unidadeRegionalId: unidadeRegionalId }
            })
        },

        obterUnidadeRegional() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterPorId(
                this.$route.params.unidadeRegionalId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            if (data) {
                this.nome = data.nome
                this.codGestor = data.codGestor
                this.codUnidade = data.codUnidade
                this.codProjeto = data.codProjeto
                this.codAcao = data.codAcao
            }
        }

        // confirmarModificarLogin() {
        //     this.$swal({
        //         title: 'Modificar Login',
        //         html: `Confirma modificação do campo Login?<br>Essa ação limpará todo o formulário!!!`,
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3085d6',
        //         cancelButtonColor: '#d33',
        //         confirmButtonText: 'Sim',
        //         cancelButtonText: 'Não'
        //     }).then((result) => {
        //         if (result.value) {
        //             this.limparFormulario()
        //         }
        //     })
        // },

        // limparFormulario() {
        //     this.usuarioDto.nome = ''
        //     this.usuarioDto.login = ''
        //     this.usuarioDto.email = ''
        //     this.loginAdValido = false
        // }
    },

    created() {
        this.obterGestores()
        this.obterUnidades()
        if (this.operacao == 'ATUALIZAR') {
            this.obterUnidadeRegional()
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        operacao() {
            return this.$route.name ==
                'AppSebrae_Consultorias_UnidadesRegionais_Inserir'
                ? 'INSERIR'
                : 'ATUALIZAR'
        },

        gestor() {
            if (this.codGestor && this.gestores) {
                return this.gestores.find((p) => p.codGestor == this.codGestor)
            }
            return null
        },

        unidade() {
            if (this.codUnidade && this.unidades) {
                return this.unidades.find(
                    (p) => p.codUnidade == this.codUnidade
                )
            }
            return null
        },

        projeto() {
            if (this.codProjeto && this.projetos) {
                return this.projetos.find(
                    (p) => p.codProjeto == this.codProjeto
                )
            }
            return null
        },

        acao() {
            if (this.codAcao && this.acoes) {
                return this.acoes.find((p) => p.codAcao == this.codAcao)
            }
            return null
        }
    },

    validations: {
        nome: {
            required
        },
        gestor: {
            required
        },
        unidade: {
            required
        },
        projeto: {
            required
        },
        acao: {
            required
        }
    },

    watch: {
        codUnidade(newVal, oldVal) {
            if (this.operacao == 'INSERIR') {
                if (newVal !== null) {
                    this.codProjeto = null
                    this.codAcao = null
                    this.acoes = []
                }
            } else {
                if (newVal !== null && oldVal !== null) {
                    this.codProjeto = null
                    this.codAcao = null
                    this.acoes = []
                }
            }
            if (newVal !== null) {
                this.obterProjetos()
            }
        },

        codProjeto(newVal, oldVal) {
            if (this.operacao == 'INSERIR') {
                if (newVal !== null) {
                    this.codAcao = null
                }
            } else {
                if (newVal !== null && oldVal !== null) {
                    this.codAcao = null
                }
            }
            if (newVal !== null) {
                this.obterAcoes()
            }
        }
    }
}
</script>
